module.exports = __webpack_public_path__ + "img/xem.ae124a50.svg";